'use client';

import {useCourseRetirementByIdQuery} from '@/generated/graphql';
import {useUserHasOrganization} from '@/lib/hooks/use-user-has-organization';

/**
 * Fetches the org-scoped course retirement date, client-side only.
 *
 * `organizationInfo.retiresOn` resolves from the viewer's JWT org context, so it must never be
 * fetched as part of the ISR'd page shell (it would bake one org's banner into the shared cache).
 */
export function useCourseRetirement(courseId: string) {
    const hasOrganization = useUserHasOrganization();

    const courseRetirement = useCourseRetirementByIdQuery(
        {id: courseId},
        {enabled: hasOrganization},
    );

    if (!hasOrganization || courseRetirement.isError) {
        return {isLoading: false, retiresOn: undefined};
    }
    const retiresOn =
        (courseRetirement.data?.course?.organizationInfo?.retiresOn as string | undefined) ??
        undefined;

    return {
        isLoading: courseRetirement.isLoading,
        retiresOn,
    };
}
